import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  availableOrders: [],
  myOrders: [],
  currentOrder: null,
  loading: false,
  error: null,
};

const shopperOrdersSlice = createSlice({
  name: 'shopperOrders',
  initialState,
  reducers: {
    setAvailableOrders(state, { payload }) {
      state.availableOrders = payload;
    },
    setMyOrders(state, { payload }) {
      state.myOrders = payload;
    },
    setCurrentOrder(state, { payload }) {
      state.currentOrder = payload;
    },
    setLoading(state, { payload }) {
      state.loading = payload;
    },
    setError(state, { payload }) {
      state.error = payload;
    },
    toggleProductTakenLocal(state, { payload }) {
      if (state.currentOrder && state.currentOrder.branchStores) {
        state.currentOrder.branchStores.forEach((store) => {
          if (store.products) {
            store.products.forEach((p) => {
              if ((p.storeBranchProduct || p.id) === payload) {
                p.taken = !p.taken;
              }
            });
          }
        });
      }
    },
  },
});

export const {
  setAvailableOrders,
  setMyOrders,
  setCurrentOrder,
  setLoading,
  setError,
  toggleProductTakenLocal,
} = shopperOrdersSlice.actions;

export default shopperOrdersSlice.reducer;
